module.exports = __webpack_public_path__ + "img/people.5692c913.png";